module.exports = {"id":"198617","name":"Dominick Drexler","rating":"73","photo":"./data/images/photos/1/198617.png","club":{"name":"Holstein Kiel","logo":"./data/images/clubs/HolsteinKiel.png"},"positions":["MOC","MG","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DominickDrexler0.json
// module id = 1134
// module chunks = 0